import { TimeRange } from '@tidbcloud/uikit/biz'

export const FEATURE_NAME = 'SQL Statement'

// unit: second
export const QUICK_RANGES: number[] = [
  30 * 60,
  60 * 60,
  6 * 60 * 60,
  12 * 60 * 60,
  24 * 60 * 60,
  2 * 24 * 60 * 60,
  3 * 24 * 60 * 60 // 3 days
]
export const DEFAULT_TIME_RANGE: TimeRange = {
  type: 'relative',
  value: QUICK_RANGES[0]
}
